<template>
    <div class="selectable-item-wrapper" @click="handleMouseClick">
        <div class="check-mark" :class="{clickable: isClickable}">
            <svg v-if="isSelected" viewBox="0 0 15 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <path stroke="#00B0D8" fill="none" stroke-width="2" d="M 1.5 6 L 5.5 9 L 11 2.5"></path>
            </svg>
        </div>
        <div class="item-label" :class="{clickable: isClickable}">
            {{ label }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'selectable-item',
    props: {
        label: String,
        isSelected: Boolean,
        unCheckable: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        isClickable() {
            if (this.unCheckable) {
                return true;
            }

            return !this.isSelected;
        }
    },
    methods: {
        handleMouseClick() {
            if (this.unCheckable) {
                this.$emit('selection-change');
            }
            if (!this.isSelected && !this.unCheckable) {
                this.$emit('selection-change');
            }
        }
    }
}
</script>

<style lang="scss">

.selectable-item-wrapper {
    display: flex;
    align-items:center;
    height: 30px;

    .clickable {
        cursor: pointer;
    }

    svg {
        vertical-align: unset;
    }

    .check-mark {
        height: 15px;
        width: 15px;
        border-style: solid;
        border-width: 1px;
        border-color: #979797;
    }

    .item-label {
        margin-left: 10px;
    }

}

</style>